<template>
	<footer id="footer">

		<section class="newsletter-section-v1" v-if="allowNewsSuscriber">
			<div class="container oversized-container">
				<div class="row flex-center-xy">
					<div class="col-md-6 col-lg-6 col-xl-7 col-title">
						<h2>Contacto empresarial</h2>
						<h5>Si requieres planes corporativos de mas de 20 líneas contáctanos</h5>
					</div>

					<div class="col-md-6 col-lg-6 col-xl-5 col-form text-right">
						<!-- <b-form @submit="onSubmit"> -->
							<!-- <b-form-group>
								<b-form-input v-model="form.email" type="email" placeholder="Escribe tu correo" required />
							</b-form-group> -->

							<b-button variant="primary" @click="$router.push('/contacto')" class="btn-send">Contáctanos</b-button>
						<!-- </b-form> -->
					</div>
				</div>
			</div>
		</section>

		<div class="footer-content">
			<div class="container oversized-container">
				<div class="row">
					<div class="col-sm-5 col-lg-4 col-footer">
						<div class="fix-ul">
							<div class="block">
								<h6 class="title">Ayuda</h6>
								<ul class="mb-1">
									<li><router-link to="/legales">Legales</router-link></li>
									<li><router-link to="/c/preguntas-frecuentes">Preguntas frecuentes</router-link></li>
									<li><router-link to="/contacto">Contáctanos</router-link></li>
									<li><router-link to="/glosario">Glosario</router-link></li>
									<li><a href="https://facturacion.blackfon.mx" target="_blank">Facturación en línea</a></li>
								</ul>
							</div>
							<div class="block">
								<h6 class="title">BlackFon</h6>
								<ul class="mb-1">
									<li><router-link to="/c/quienes-somos">Quiénes somos</router-link></li>
									<li><router-link to="/c/sucursales">Sucursales</router-link></li>
									<li><router-link to="/c/compatibilidad-blackfon">Compatibilidad BlackFon</router-link></li>
									<li><router-link to="/c/portabilidad-blackfon">Portabilidad BlackFon</router-link></li>
									<li><router-link to="/c/cobertura-blackfon">Cobertura BlackFon</router-link></li>
									<li><router-link to="/pages">Noticias y promociones</router-link></li>
								</ul>
							</div>
						</div>


						<p class="mt-2">
							<a class="t-250 btn-bubble btn-purple" href="tel:*611">Llamar al *611</a>
						</p>
						<!-- <p class="mt-2">
							<router-link class="t-250 btn-bubble btn-pink" to="/contacto">Enviar correo</router-link>
						</p> -->
						<!-- <p class="mt-2">
							<a class="t-250 btn-bubble btn-orange" href="#">Chat</a>
						</p> -->
					</div>

					<div class="col-sm-7 col-lg-4 col-footer">
						<h6 class="title">Aviso Legal</h6>

						<p class="mb-1" v-for="link in links" :key="link.url">
							<router-link :to="'/c/' + link.url">
								{{ link.title }}
							</router-link>
						</p>
					
					</div>

					<div class="col-lg-4 col-footer col-images">
						<div class="box">
							
							<router-link class="btn-logo" to="/">
								<img src="public/images/logo-white.svg">
							</router-link>

							<p class="mt-3 mt-lg-5">
								<a class="t-250 btn-app" target="_blank" href="https://play.google.com/store/apps/details?id=app.blackfon.tel">
									<img src="public/images/shared/google-play.svg">
								</a>
							</p>
							<p class="mt-3">
								<a class="t-250 btn-app" target="_blank" href="https://apps.apple.com/mx/app/blackfon/id6747028112">
									<img src="public/images/shared/app-store.svg">
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

	</footer>
</template>

<script>

export default {
	data() {
		return {
			form: {
				email: null,
			}
		}
	},

	props: {
		links: {
			type: Array,
			default: () => [
				{
					title: 'POLÍTICA DE USO DE LOS SERVICIOS BLACKFON',
					url: 'politica-de-uso-de-los-servicios-blackfon'
				},
				{
					title: 'CÓDIGO DE POLÍTICAS DE GESTIÓN DE TRÁFICO Y ADMINISTRACIÓN DE RED',
					url: 'codigo-de-politicas-de-gestion-de-trafico-y-administracion-de-red'
				},
				{
					title: 'CÓDIGO DE PRÁCTICAS COMERCIALES DE BLACKFON',
					url: 'codigo-de-practicas-comerciales-de-blackfon'
				},
				{
					title: 'INFORMACIÓN SOBRE COLABORACIÓN EN MATERIA DE SEGURIDAD Y JUSTICIA',
					url: 'informacion-sobre-colaboracion-en-materia-de-seguridad-y-justicia'
				},
				{
					title: 'AVISO DE PRIVACIDAD INTEGRAL – BLACKFON',
					url: 'aviso-de-privacidad-integral-–-blackfon'
				},
				{
					title: 'TERMINOS Y CONDICIONES',
					url: 'terminos-y-condiciones'
				},
			]
		},
		noNewSuscriptionNames: {
			type: Array,
			default: () => {
				return [
					'contrata-ya'
				]
			}
		}
	},

	computed: {
		allowNewsSuscriber(){
			return (this.noNewSuscriptionNames.indexOf(this.$route.name) == -1);
		}
	},

	methods: {
		onSubmit(evt) {
			evt.preventDefault();
			var r = confirm("¿Deseas regístrate en newsletter? ");
			if (r == true) {
				axios.post(tools.url("/newsletter"), this.form).then((response) => {
					this.makeToast('default', response.data.response, 'Message sent');
					this.form = {
						email: null,
					};
				}).catch((error) => {
					// console.log(error.response);
					let errors = error.response.data;
					// console.log(errors);
					this.makeToast('danger', error.response.data.email, 'Error');
				});
			}
		}
	}
}
</script>

<style lang="scss">
	.fix-ul {
		gap: 1em;
		display: flex;
		flex-flow: column;
		text-transform: uppercase;
		ul {
			padding: 0;
			margin: 0;
			li {
				list-style: none;
				padding: 0;
				margin: 0;
			}
		}
	}
</style>